import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { FormLayout, Skeleton } from "src/components"

interface WarrantyDataViewSkeletonProps {
	isEditMode: boolean
}

export const WarrantySkeleton = ({ isEditMode }: WarrantyDataViewSkeletonProps) => {
	const listItemCount = isEditMode ? 3 : 4
	return (
		<SkeletonWrapper data-testid="warranty-data-view-skeleton">
			{isEditMode && <Skeleton.Checkbox />}
			<FormLayout $width="half">
				<Skeleton.List entries={listItemCount} />
			</FormLayout>
		</SkeletonWrapper>
	)
}

const SkeletonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`
